import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { UserService } from "../../services/userService";
import { useSelector } from "react-redux";
import * as Yup from 'yup';
import toastr from 'toastr';

export default function ModalAddAddress(props) {
    const initialValues = {
        Nomenclatura: '',
        Referencia: '',
        NombreRecibe: '',
        Telefono: '',
        esPrincipal: 'No',
        dateRegister: new Date().toISOString(),
        latitud: '',
        longitud: '',
        barrio: '',
        tipoIdRecibe: '',
        numDocRecibe: '',
        ciudad: '',
        departamento: '',
    };

    const formValidation = Yup.object().shape({
        Nomenclatura: Yup.string().required("Campo requerido"),
        NombreRecibe: Yup.string().required("Campo requerido"),
        Telefono: Yup.string().required("Campo requerido"),
    });

    const user = useSelector(state => state.Login.user);
    const userService = new UserService();
    const [saveOnce, setSaveOnce] = useState(false);

    const onSubmit = async values => {
        if (saveOnce) return;
        setSaveOnce(true);

        if (!user || !user.id) {
            console.error("Usuario no definido");
            toastr.error("No se pudo enviar el formulario. Usuario no definido.");
            setSaveOnce(false);
            return;
        }

        const request = {
            ...values,
            id: 0,
            idPersona: user.id,
            userId: `${user.id}`,
            dateRegister: new Date().toISOString(),
        };

        try {
            const response = await userService.addAddress(request);

            if (response?.success || response === 1) {
                toastr.success("Dirección agregada exitosamente");

                if (typeof props.addressSaved === "function") {
                    props.addressSaved(request);
                }
            } else {
                toastr.warning("No se pudo agregar la dirección");
            }
        } catch (error) {
            console.error("Error al enviar dirección:", error);
            toastr.error("Hubo un error al guardar la dirección.");
        } finally {
            setSaveOnce(false);
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={formValidation}
            onSubmit={onSubmit}
        >
            <Form>
                <div className="form-group">
                    <label htmlFor="Nomenclatura" className="control-label">Dirección</label>
                    <Field name="Nomenclatura" id="Nomenclatura" type="text" className="form-control" placeholder="" />
                    <ErrorMessage name="Nomenclatura">{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                </div>

                <div className="form-group">
                    <label htmlFor="Referencia" className="control-label">Alias</label>
                    <Field name="Referencia" id="Referencia" type="text" className="form-control" placeholder="" />
                    <ErrorMessage name="Referencia">{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                </div>

                <div className="form-group">
                    <label htmlFor="NombreRecibe" className="control-label">Nombre de quién recibe</label>
                    <Field name="NombreRecibe" id="NombreRecibe" type="text" className="form-control" placeholder="" />
                    <ErrorMessage name="NombreRecibe">{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                </div>

                <div className="form-group">
                    <label htmlFor="Telefono" className="control-label">Teléfono</label>
                    <Field name="Telefono" id="Telefono" type="text" className="form-control" placeholder="" />
                    <ErrorMessage name="Telefono">{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                </div>

                <div className="mt-4">
                    <button className="boton3-fanero btn-block" type="submit">Guardar</button>
                </div>
            </Form>
        </Formik>
    );
}
